
  export default {
    mounted() {
      // Canvas setup
      const canvas = document.createElement('canvas');
      const dpr = window.devicePixelRatio || 1;
      Object.assign(canvas.style, {
        position: 'absolute',
        inset: '0px',
        pointerEvents: 'none',
        zIndex: '5'
      });
      this.el.appendChild(canvas);

      const ctx = canvas.getContext("2d", { willReadFrequently: true });

      const state = {
        widthCss: 0,
        heightCss: 0,
        particles: [],
      };

      const resize = () => {
        const rect = this.el.getBoundingClientRect();
        state.widthCss = Math.max(rect.width, 360); // honor min supported width
        state.heightCss = Math.max(rect.height, 140);
        canvas.style.width = state.widthCss + 'px';
        canvas.style.height = state.heightCss + 'px';
        canvas.width = Math.floor(state.widthCss * dpr);
        canvas.height = Math.floor(state.heightCss * dpr);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
      };

      resize();
      this._resizeObserver = new ResizeObserver(resize);
      this._resizeObserver.observe(this.el);

      const colors = ['#7F00FF', '#FF2D55', '#FFC700', '#00D084', '#41BBC7'];
      const gravity = 0.15;
      const drag = 0.005;
      const terminal = 3.5;
      const spread = Math.PI / 2; // 90 degrees
      const startVelocity = 6;

      function rand(min, max) { return Math.random() * (max - min) + min; }

      const makeBurst = (count = 80) => {
        const originX = state.widthCss / 2;
        const originY = state.heightCss * 0.1;
        for (let i = 0; i < count; i++) {
          const angle = rand(-spread / 2, spread / 2) - Math.PI / 2; // upwards fan
          const velocity = rand(startVelocity * 0.6, startVelocity * 1.25);
          state.particles.push({
            x: originX,
            y: originY,
            wobble: rand(0, 10),
            wobbleSpeed: rand(0.08, 0.15),
            velocityX: Math.cos(angle) * velocity,
            velocityY: Math.sin(angle) * velocity,
            size: rand(4, 7),
            color: colors[Math.floor(Math.random() * colors.length)],
            tilt: rand(0, Math.PI),
            tiltSpeed: rand(0.08, 0.2)
          });
        }
      };

      // Initial burst
      makeBurst(100);

      const draw = () => {
        ctx.clearRect(0, 0, state.widthCss, state.heightCss);

        state.particles.forEach((p) => {
          p.x += p.velocityX;
          p.y += p.velocityY;
          p.velocityX *= (1 - drag);
          p.velocityY = Math.min(p.velocityY + gravity, terminal);
          p.tilt += p.tiltSpeed;
          p.wobble += p.wobbleSpeed;

          const wobbleX = p.x + Math.cos(p.wobble) * 2;
          const wobbleY = p.y + Math.sin(p.wobble) * 2;

          ctx.save();
          ctx.translate(wobbleX, wobbleY);
          ctx.rotate(p.tilt);
          ctx.fillStyle = p.color;
          const s = p.size;
          ctx.fillRect(-s / 2, -s / 2, s, s);
          ctx.restore();
        });

        // Cull particles off-screen to keep performance stable
        state.particles = state.particles.filter((p) => p.y < state.heightCss + 20);

        this._raf = requestAnimationFrame(draw);
      };

      this._raf = requestAnimationFrame(draw);

      // Repeat bursts at intervals for a continuous celebration
      this._interval = setInterval(() => makeBurst(70), 1800);
      this._canvas = canvas;
    }
    ,
    destroyed() {
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._interval) clearInterval(this._interval);
      if (this._resizeObserver) this._resizeObserver.disconnect();
      if (this._canvas && this._canvas.parentNode) this._canvas.parentNode.removeChild(this._canvas);
    }
  }
